import { render, staticRenderFns } from "./CasePage.vue?vue&type=template&id=7c100e64&"
import script from "./CasePage.vue?vue&type=script&lang=js&"
export * from "./CasePage.vue?vue&type=script&lang=js&"
import style0 from "./CasePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports